import { DeviceAuthorizePage } from "@/ui/DeviceAuthorizePage";

export const DeviceAuthorizeRoute = () => <DeviceAuthorizePage />;
